const SCHEMA_NAME_APPRAISAL_REAL_ESTATE = 'appraisal_real_estate'
const SCHEMA_NAME_APPRAISAL_LAND_REGISTER = 'appraisal_land_register'
const SCHEMA_NAME_MAIN_VALUATION = 'main_valuation'
export {SCHEMA_NAME_APPRAISAL_REAL_ESTATE, SCHEMA_NAME_APPRAISAL_LAND_REGISTER, SCHEMA_NAME_MAIN_VALUATION}
